export const removeParenthesesContent = (text: string) => {
    return text.replace(/ *\([^)]*\) */g, '')
}
